import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import React__default, { useEffect, useMemo, Fragment } from 'react';
import { useFormContext } from 'react-hook-form';
import { CgAlignBottom } from '@react-icons/all-files/cg/CgAlignBottom';
import { CgAlignMiddle } from '@react-icons/all-files/cg/CgAlignMiddle';
import { CgAlignTop } from '@react-icons/all-files/cg/CgAlignTop';
import { ToggleField, SelectField, NumberInputField, RadioField } from '@bucketplace/commerce-admin-ui';
import { BREAK_POINT_NAMES } from '@bucketplace/design-system';
import { Divider } from '@bucketplace/design-system/bds';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import '../../../contexts/internal/StickyContext.js';
import '../../../contexts/internal/EditorContext.js';
import '../../../components/Canvas/Canvas.style.js';
import '../../../components/Canvas/PreviewModeContainer.js';
import '../../../components/Duration/DurationInput.js';
import '../../../components/FieldItem.js';
import '../../../components/FormGroup/FormGroup.js';
import '../../../components/FormGroup/LogDataFormGroup.js';
import '../../../components/Header/index.js';
import '../../../components/Input/ColorPickerField/index.js';
import '../../../components/Input/URLInput.js';
import '../../../components/Inspector/Inspector.js';
import '../../../components/TreeList/TreeList.style.js';
import '@react-icons/all-files/hi/HiChevronDown';
import '@react-icons/all-files/hi/HiChevronRight';
import '@react-icons/all-files/ri/RiCloseCircleFill';
import '@react-icons/all-files/ri/RiDeleteBinLine';
import '@react-icons/all-files/ri/RiFileCopyLine';
import '@react-icons/all-files/ri/RiShapeLine';
import 'qs';
import 'query-string';
import '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import '@bucketplace/bucket-log';
import 'react-dom';
import '../../../components/Tooltip/Tooltip.js';
import '../../../components/Toolbar/Toolbar.style.js';
import '../../../components/TreeList/Draggable.js';
import '../../../components/EditorPlaceholder/EditorPlaceholder.js';
import { FormContent } from '../../../components/FormContent.js';
import { InspectorFormProvider } from '../../../components/InspectorFormProvider.js';
import { INITIAL_GRID_DATA, BREAK_POINT_OPTIONS } from '../types.js';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var COLUMN_OPTIONS = [{
  text: '1',
  value: 1
}, {
  text: '2',
  value: 2
}, {
  text: '3',
  value: 3
}, {
  text: '4',
  value: 4
}];
var VERTICAL_ALIGN_OPTIONS = [{
  text: jsx(CgAlignTop, null),
  value: 'flex-start'
}, {
  text: jsx(CgAlignMiddle, null),
  value: 'center'
}, {
  text: jsx(CgAlignBottom, null),
  value: 'flex-end'
}];
function GridInspector(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  return jsx(InspectorFormProvider, {
    value: value,
    onChange: onChange
  }, jsx(Grid, null));
}
function Grid() {
  var _useFormContext = useFormContext(),
    getValues = _useFormContext.getValues,
    setValue = _useFormContext.setValue;
  var value = getValues();
  var handleChangeFlag = function handleChangeFlag(type, flagValue) {
    setValue(type, flagValue ? INITIAL_GRID_DATA : null);
  };
  useEffect(function () {
    var hasBreakPoint = Object.entries(value).some(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];
      return BREAK_POINT_NAMES.some(function (name) {
        return name === key;
      }) && value;
    });
    if (!hasBreakPoint) {
      setValue('mobile', INITIAL_GRID_DATA);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setValue, value]);

  /** 마지막 체크를 지울 수 없도록 막는데 사용 */
  var checkedCount = useMemo(function () {
    var count = 0;
    BREAK_POINT_NAMES.forEach(function (point) {
      if (value[point] != null) {
        count += 1;
      }
    });
    return count;
  }, [BREAK_POINT_NAMES, value]);
  return jsx(React__default.Fragment, null, BREAK_POINT_OPTIONS.map(function (option, index) {
    var data = value[option.value];
    return jsx(Fragment, {
      key: "".concat(option.value)
    }, jsx(FormContent, {
      header: option.label
    }, jsx(ToggleField, {
      name: option.value,
      disabled: checkedCount === 1 && data != null,
      onCheck: function onCheck(value) {
        return handleChangeFlag(option.value, value);
      }
    })), data && jsx(GridInput, {
      type: option.value
    }), BREAK_POINT_OPTIONS.length - 1 > index && jsx(Divider, {
      variant: "thick"
    }));
  }));
}
function GridInput(_ref4) {
  var type = _ref4.type;
  var _useFormContext2 = useFormContext(),
    getValues = _useFormContext2.getValues,
    setValue = _useFormContext2.setValue;
  var _getValues = getValues(type),
    column = _getValues.column,
    _getValues$columnRati = _getValues.columnRatio,
    columnRatio = _getValues$columnRati === void 0 ? [] : _getValues$columnRati;
  useEffect(function () {
    if (columnRatio.length === column) {
      return;
    }
    setValue("".concat(type, ".columnRatio"), Array(column).fill(1));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [column]);
  return jsx("div", null, jsx(FormContent, {
    header: "\uC5F4 \uAC2F\uC218"
  }, jsx(SelectField, {
    name: "".concat(type, ".column"),
    options: COLUMN_OPTIONS
  })), jsx(FormContent, {
    header: "\uBE44\uC728(N:N)"
  }, jsx(GapWrapper, null, columnRatio.map(function (_, ratioIndex) {
    return jsx(NumberInputField, {
      key: "".concat(ratioIndex + 1),
      name: "".concat(type, ".columnRatio.").concat(ratioIndex),
      width: "100%"
    });
  }))), jsx(FormContent, {
    header: "\uAC04\uACA9"
  }, jsx(NumberInputField, {
    name: "".concat(type, ".gap")
  })), jsx(FormContent, {
    header: "\uC138\uB85C\uCD95 \uC815\uB82C"
  }, jsx(RadioField, {
    name: "".concat(type, ".verticalAlign"),
    options: VERTICAL_ALIGN_OPTIONS
  })));
}
var GapWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1mktp3p0"
} : {
  target: "e1mktp3p0",
  label: "GapWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "7kxp26",
  styles: "display:grid;grid-template-columns:repeat(2, 1fr);gap:8px"
} : {
  name: "7kxp26",
  styles: "display:grid;grid-template-columns:repeat(2, 1fr);gap:8px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export { GridInspector };
//# sourceMappingURL=index.js.map
